'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _botManager = require('./bot-manager.component');

var _botManager2 = _interopRequireDefault(_botManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botManagerModule = _angular2.default.module('app.containers.bot-manager', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('botManager', {
    url: '/bot-manager',
    template: '<bot-manager></bot-manager>'
  });
}).component('botManager', _botManager2.default);

exports.default = botManagerModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-manager/bot-manager.js
 **/